<div class="actualizar-reportes-container">
  <!-- Header con título y botón -->
  <nz-spin nzSize="large" [nzSpinning]="actualizando">
  <div class="header-container">
    <h2 class="titulo">Actualizar Reportes</h2>
    
    <button 
      nz-button 
      nzType="primary" 
      nzDanger
      class="excel-button"
      [disabled]="actualizando"
      (click)="actualizar()"
    >
      <i nz-icon nzType="sync" nzTheme="outline"></i>
      Actualizar
    </button>
  </div>
  
  <div class="tabla-container">
    <nz-table 
      #basicTable 
      [nzData]="reportes || []" 
      class="tabla-reportes"
      [nzPageSize]="10"
      [nzShowPagination]="true"
    >
      <thead>
        <tr>
          <th class="col-fecha bold">Fecha de Solicitud</th>
          <th class="col-estatus bold">Estatus</th>
          <th class="col-monto bold">Monto Aprobado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of basicTable.data">
          <td class="col-fecha">
            {{ item.fechaSolicitud | date:'dd/MM/yyyy' }}
          </td>
          <td class="col-estatus">
            <div 
              class="estatus-badge"
              [style.background-color]="getEstatusColor(item.estatusSolicitud)"
            >
              <img 
                [src]="getEstatusIcon(item.estatusSolicitud)" 
                class="estatus-icon"
                alt="Estatus icon"
              />
              <span class="estatus-text">{{ item.estatusSolicitud }}</span>
            </div>
          </td>
          <td class="col-monto">
            <span>
              {{ item.montoTotalAutorizado | currency:'MXN':'symbol':'1.2-2' }}
            </span>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  </nz-spin>
</div>
